import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useEffect, useRef } from "react";

import "./DropdownMultiselect.scss";

interface Option {
  label: string;
  value: string | number;
}

interface DropdownMultiselectProps {
  width: number;
  darkMode?: boolean;
  options: Option[];
  label: string;
  all: string;
  selected: Option[];
  onChange: (selected: any[]) => void;
  resetting?: boolean;
  onResetEnded?: () => void;
  isOpen?: boolean;
  onToggle?: () => void;
  id?: string;
}

const DropdownMultiselect = (props: DropdownMultiselectProps) => {
  const [internalIsOpen, setInternalIsOpen] = useState(false);

  const isOpen = props.isOpen !== undefined ? props.isOpen : internalIsOpen;

  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        if (props.onToggle && isOpen) {
          props.onToggle();
        } else {
          setInternalIsOpen(false);
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, props]);

  const handleCheckboxChange = (option: Option) => {
    const newSelected = props.selected;
    const index = newSelected.findIndex((item) => item.value === option.value);
    if (index >= 0) newSelected.splice(index, 1);
    else newSelected.push(option);
    props.onChange(newSelected);
  };

  const handleSelectAll = () => {
    props.onChange(
      props.selected.length === props.options.length ? [] : props.options
    );
  };

  return (
    <div
      ref={dropdownRef}
      className={
        "multi-select-dropdown-container" + (props.darkMode ? " dark" : "")
      }
    >
      <div
        className={
          "multi-select-dropdown-header" + (props.darkMode ? " dark" : "")
        }
        onClick={() => {
          if (props.onToggle) {
            props.onToggle();
          } else {
            setInternalIsOpen((prev) => !prev);
          }
        }}
      >
        <span
          className={
            (props.selected.length > 0
              ? "placeholder-style-selected"
              : "placeholder-style") + (props.darkMode ? " dark" : "")
          }
        >
          {props.selected.length
            ? `${props.selected.map((s) => s.label).join(", ")}`
            : props.all}
        </span>
        <FontAwesomeIcon
          icon={faAngleDown}
          className={
            "multi-select-dropdown-arrow" + (props.darkMode ? " dark" : "")
          }
        />
      </div>

      {isOpen && (
        <div
          className={
            "multi-select-dropdown-options" + (props.darkMode ? " dark" : "")
          }
          // style={{ width: (15 * scaleMultiplier) + 'rem', padding: (5 * scaleMultiplier) + 'px 0' }}
        >
          {/* Select All */}
          <div
            className={
              "multi-select-dropdown-select-all" +
              (props.darkMode ? " dark" : "")
            }
          >
            <input
              type="checkbox"
              className="custom-checkbox"
              checked={props.selected.length === props.options.length}
              onChange={handleSelectAll}
            />
            <label className="multi-select-dropdown-select-all-label">
              Select All
            </label>
          </div>

          {/* Options */}
          {props.options.map((option) => (
            <div
              key={option.value}
              className={`multi-select-dropdown-option ${
                props.darkMode ? "dark" : ""
              } ${
                props.selected.some((s) => s.value === option.value)
                  ? "selected"
                  : ""
              }`}
            >
              <input
                type="checkbox"
                className="custom-checkbox"
                checked={props.selected.some((s) => s.value === option.value)}
                onChange={() => handleCheckboxChange(option)}
              />
              <label className="multi-select-dropdown-option-label">
                {option.label}
              </label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DropdownMultiselect;
